import React from 'react';

const Panel = (props) => {
  return (

    <div className='panel panel-default custom bordeado info-extra'>
      <div className='panel-body'>
        {props.children}
      </div>
    </div>
  );

};

export default Panel;
